import * as angular from 'angular';

const textfeldIcon = require('../images/icons/textfeld.svg');
const textfeldAjaxIcon = require('../images/icons/textfeld_ajax.svg');
const currencyIcon = require('../images/icons/currency.svg');
const textbereichIcon = require('../images/icons/textbereich.svg');
const uploadIcon = require('../images/icons/upload.svg');
const jaNeinFeldIcon = require('../images/icons/janeinfeld.svg');
const textanzeigeIcon = require('../images/icons/textanzeige.svg');
const buttonIcon = require('../images/icons/button.svg');
const checkboxIcon = require('../images/icons/checkbox.svg');
const radiobuttonIcon = require('../images/icons/radiobutton.svg');
const selectfeldIcon = require('../images/icons/selectfeld.svg');
const selectfeldAjaxIcon = require('../images/icons/selectfeld_ajax.svg');
const multiselectfeldIcon = require('../images/icons/multiselectfeld.svg');
const schubserelementIcon = require('../images/icons/schubserelement.svg');
const datumsfeldIcon = require('../images/icons/datumsfeld.svg');
const zeitfeldIcon = require('../images/icons/zeitfeld.svg');
const headline1Icon = require('../images/icons/headline1.svg');
const headline2Icon = require('../images/icons/headline2.svg');
const platzhalterIcon = require('../images/icons/platzhalter.svg');
const npaIcon = require('../images/icons/npa.svg');
const videoIcon = require('../images/icons/video.svg');
const playIcon = require('../images/icons/play.svg');
const imageIcon = require('../images/icons/image.svg');
const downloadIcon = require('../images/icons/download.svg');
const kfzKennzeichenIcon = require('../images/icons/kfzKennzeichen.svg');
const hintboxIcon = require('../images/icons/hintboxIcon.svg');
const hintboxSuccessIcon = require('../images/icons/hintboxCheck.svg');
const hintboxErrorIcon = require('../images/icons/hintboxError.svg');
const hintboxQuestionIcon = require('../images/icons/hintboxUnknown.svg');
const hintboxInfoIcon = require('../images/icons/hintboxAttention.svg');

const mappings = {
  dropdownOptions: {
    npaFields: [
      {
        key: 'titel',
        value: 'Titel'
      },
      {
        key: 'vorname',
        value: 'Vorname'
      },
      {
        key: 'nachname',
        value: 'Nachname'
      },
      {
        key: 'strasse',
        value: 'Straße'
      },
      {
        key: 'hausnummer',
        value: 'Hausnummer'
      },
      {
        key: 'strasseUndHausnummer',
        value: 'Straße und Hausnummer'
      },
      {
        key: 'plz',
        value: 'Postleitzahl'
      },
      {
        key: 'ort',
        value: 'Ort'
      },
      {
        key: 'bundesland',
        value: 'Bundesland'
      },
      {
        key: 'land',
        value: 'Land'
      },
      {
        key: 'geburtsdatum',
        value: 'Geburtsdatum'
      },
      {
        key: 'geburtsort',
        value: 'Geburtsort'
      },
      {
        key: 'staatsangehoerigkeit',
        value: 'Staatsangehörigkeit'
      },
      {
        key: 'geburtsname',
        value: 'Geburtsname'
      },
      {
        key: 'kuenstlername',
        value: 'Künstlername'
      },
      {
        key: 'dokumentart',
        value: 'Dokumentart'
      },
      {
        key: 'ablaufdatum',
        value: 'Ablaufdatum'
      },
      {
        key: 'ausstellenderStaat',
        value: 'Ausstellender Staat'
      },
      {
        key: 'nebenbestimmungenI',
        value: 'Nebenbestimmungen I'
      }
    ],
    autocompleteType: [
      {
        key: 'honorific-prefix',
        value: 'Anrede (honorific-prefix)'
      },
      {
        key: 'given-name',
        value: 'Vorname (given-name)'
      },
      {
        key: 'additional-name',
        value: 'Zweiter Vorname (additional-name)'
      },
      {
        key: 'family-name',
        value: 'Familienname (family-name)'
      },
      {
        key: 'honorific-suffix',
        value: 'Titel (honorific-suffix)'
      },
      {
        key: 'email',
        value: 'E-Mail (email)'
      },
      {
        key: 'organization-title',
        value: 'Stellenbezeichnung (organization-title)'
      },
      {
        key: 'organization',
        value: 'Organisation / Firma (organization)'
      },
      {
        key: 'street-address',
        value: 'Adresse (street-address)'
      },
      {
        key: 'shipping',
        value: 'Lieferanschrift (shipping)'
      },
      {
        key: 'billing',
        value: 'Rechnungsanschrift (billing)'
      },
      {
        key: 'address-level1',
        value: 'Adressstufe 1: Bundesland (address-level1)'
      },
      {
        key: 'address-level2',
        value: 'Adressstufe 2: Stadt, Gemeinde, Ort (address-level2)'
      },
      {
        key: 'address-level3',
        value: 'Adressstufe 3: Stadtteil, Bezirk (address-level3)'
      },
      {
        key: 'address-level4',
        value: 'Adressstufe 4: Viertel,  Unterbezirk (address-level4)'
      },
      {
        key: 'country',
        value: 'Länder- oder Gebietscode (country)'
      },
      {
        key: 'country-name',
        value: 'Ländername (country-name)'
      },
      {
        key: 'postal-code',
        value: 'Postleitzahl (postal-code)'
      },
      {
        key: 'bday',
        value: 'Geburtsdatum (bday)'
      },
      {
        key: 'bday-day',
        value: 'Geburtstagstag (bday-day)'
      },
      {
        key: 'bday-month',
        value: 'Geburtstagsmonat (bday-month)'
      },
      {
        key: 'bday-year',
        value: 'Geburtstagsjahr (bday-year)'
      },
      {
        key: 'sex',
        value: 'Geschlecht (sex)'
      },
      {
        key: 'tel',
        value: 'Telefonnummer (tel)'
      },
      {
        key: 'tel-country-code',
        value: 'Ländervorwahl (tel-country-code)'
      },
      {
        key: 'tel-national',
        value: 'Telefonnummer ohne Ländervorwahl (tel-national)'
      },
      {
        key: 'tel-area-code',
        value: 'Ortsvorwahl (tel-area-code)'
      },
      {
        key: 'tel-local',
        value: 'Telefonnummer ohne Länder- oder Ortsvorwahl (tel-local)'
      },
      {
        key: 'url',
        value: 'URL (url)'
      }
    ],
    loaFields: [
      {
        key: 'vorname',
        value: 'Vorname'
      },
      {
        key: 'nachname',
        value: 'Nachname / Firmenname'
      },
      {
        key: 'email',
        value: 'E-Mail'
      },
      {
        key: 'strasseUndHausnummer',
        value: 'Straße und Hausnummer'
      },
      {
        key: 'ort',
        value: 'Ort'
      },
      {
        key: 'plz',
        value: 'PLZ'
      },
      {
        key: 'land',
        value: 'Land'
      },
      {
        key: 'geburtsOrt',
        value: 'Geburtsort'
      },
      {
        key: 'geburtsDatum',
        value: 'Geburtsdatum'
      },
      {
        key: 'geburtsName',
        value: 'Geburtsname'
      }
    ],
    months: [
      { value: '', label: '' },
      { value: '01', label: '01' },
      { value: '02', label: '02' },
      { value: '03', label: '03' },
      { value: '04', label: '04' },
      { value: '05', label: '05' },
      { value: '06', label: '06' },
      { value: '07', label: '07' },
      { value: '08', label: '08' },
      { value: '09', label: '09' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' }
    ]
  },
  elements: {
    form: {
      allowedValidationRules: [],
      allowedDisplayConditions: [],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.'
    },
    custom_buttons: {
      allowedValidationRules: [],
      allowedDisplayConditions: [],
      descrPlaceholder: ''
    },
    section: {
      allowedValidationRules: [],
      allowedDisplayConditions: [],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.'
    },
    fieldgroup: {
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.'
    },
    media_accordion: {
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.'
    },
    media_accordion_element: {
      allowedValidationRules: [],
      allowedDisplayConditions: []
    },
    table: {
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.'
    },
    row: {
      allowedValidationRules: [],
      allowedDisplayConditions: []
    },
    string: {
      valueType: 'single',
      label: 'Einzeiliges Textfeld',
      icon: textfeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'MaxLengthValidator',
        'NumberValidator',
        'MinNumberValueValidator',
        'MaxNumberValueValidator',
        'RegexValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    string_ajax_autocomplete: {
      valueType: 'single',
      label: 'Textfeld mit Vorschlagsliste',
      icon: textfeldAjaxIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'MaxLengthValidator',
        'NumberValidator',
        'MinNumberValueValidator',
        'MaxNumberValueValidator',
        'RegexValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    euro_betrag: {
      valueType: 'single',
      label: 'Geldbetrag',
      icon: currencyIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'EuroBetragPositiveValidator',
        'EuroBetragNegativeValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    textarea: {
      valueType: 'single',
      label: 'Mehrzeiliges Textfeld',
      icon: textbereichIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'MaxLengthValidator',
        'RegexValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    file: {
      label: 'Upload (Deprecated)',
      icon: uploadIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'FileExtensionValidator',
        'MaxFilesizeValidator',
        'MaxTotalFilesizeValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    multiple_file: {
      label: 'Upload',
      icon: uploadIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'FileExtensionValidator',
        'MaxFilesizeValidator',
        'MaxFileCountValidator',
        'FileNameRegexValidator',
        'MaxTotalFilesizeValidator',
        'PdfAValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    boolean: {
      valueType: 'boolean',
      label: 'Ja/Nein-Feld',
      icon: jaNeinFeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    text: {
      label: 'Textanzeige',
      icon: textanzeigeIcon,
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Text ein.',
      allowedInMediaAccordionElement: true
    },
    submitted_with_npa_info: {
      label: 'NPA Info',
      icon: npaIcon,
      allowedValidationRules: [],
      allowedDisplayConditions: []
    },
    button: {
      label: 'Button',
      icon: buttonIcon,
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    checkbox: {
      valueType: 'multiple',
      label: 'Checkbox',
      icon: checkboxIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    single_checkbox: {
      valueType: 'boolean',
      label: 'Einfache Checkbox',
      icon: checkboxIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    radio_buttons: {
      valueType: 'single',
      label: 'Radiobutton',
      icon: radiobuttonIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    dropdown_single_select: {
      valueType: 'single',
      label: 'Dropdown',
      icon: selectfeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    dropdown_single_select_ajax: {
      valueType: 'single',
      label: 'Abhängiges Dropdown',
      icon: selectfeldAjaxIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    dropdown_multiple_select: {
      valueType: 'multiple',
      label: 'Multi-Select-Feld',
      icon: multiselectfeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    two_list_select: {
      valueType: 'multiple',
      label: 'Schubser',
      icon: schubserelementIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    date: {
      valueType: 'date',
      label: 'Datumsfeld',
      icon: datumsfeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator',
        'MaxDateValueValidator',
        'MinDateValueValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    time: {
      valueType: 'time',
      label: 'Zeitfeld',
      icon: zeitfeldIcon,
      allowedValidationRules: [
        'ExternalValidator',
        'VerificationLevelValidator',
        'RequiredOnEmptyFieldValidator',
        'RequiredOnFilledFieldValidator',
        'RequiredOnFieldValueValidator',
        'RequiredOnFieldValueNotInValuesValidator'
      ],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    h1: {
      label: 'Überschrift 1',
      icon: headline1Icon,
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.',
      allowedInMediaAccordionElement: true
    },
    h2: {
      label: 'Überschrift 2',
      icon: headline2Icon,
      allowedValidationRules: [],
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte einen Titel ein.',
      allowedInMediaAccordionElement: true
    },
    placeholder: {
      label: 'Abstandshalter',
      icon: platzhalterIcon,
      allowedValidationRules: []
    },
    video: {
      label: 'Video',
      icon: videoIcon,
      playIcon: playIcon,
      fixedWidth: true,
      disallowInMultipleFieldGroups: true,
      allowedInMediaAccordionElement: true
    },
    image: {
      label: 'Bild',
      icon: imageIcon,
      fixedWidth: true,
      disallowInMultipleFieldGroups: true,
      allowedInMediaAccordionElement: true
    },
    download: {
      label: 'Download',
      icon: downloadIcon,
      fixedWidth: true,
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    kfz_kennzeichen: {
      label: 'Kennzeichen',
      icon: kfzKennzeichenIcon,
      fixedWidth: true,
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Bezeichnung ein.'
    },
    hintbox: {
      label: 'Hinweisbox',
      icon: hintboxIcon,
      status: {
        SUCCESS: hintboxSuccessIcon,
        ERROR: hintboxErrorIcon,
        QUESTION: hintboxQuestionIcon,
        INFO: hintboxInfoIcon
      },
      fixedWidth: true,
      disallowInMultipleFieldGroups: true,
      allowedDisplayConditions: [
        'ShowOnProcessVariableInValuesCondition',
        'ShowOnProcessVariableNotInValuesCondition',
        'ShowOnEmptyFieldCondition',
        'ShowOnFilledFieldCondition',
        'ShowOnFieldValuesCondition',
        'ShowOnFieldValueNotInValuesCondition',
        'AndCondition'
      ],
      descrPlaceholder: 'Geben Sie bitte eine Überschrift ein.'
    }
  },
  displayConditions: {
    ShowOnEmptyFieldCondition: {
      displayName: 'Sichtbar wenn Referenzfeld leer',
      template: {
        '@type': 'ShowOnEmptyFieldCondition',
        conditionFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        }
      },
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select',
        'date',
        'time',
        'euro_betrag'
      ]
    },
    ShowOnFilledFieldCondition: {
      displayName: 'Sichtbar wenn Referenzfeld ausgefüllt',
      template: {
        '@type': 'ShowOnFilledFieldCondition',
        conditionFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        }
      },
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select',
        'date',
        'time',
        'euro_betrag'
      ]
    },
    ShowOnFieldValuesCondition: {
      displayName: 'Sichtbar wenn Referenzfeld Wert(e) hat',
      template: {
        '@type': 'ShowOnFieldValuesCondition',
        conditionFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        },
        values: []
      },
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select'
      ]
    },
    ShowOnFieldValueNotInValuesCondition: {
      displayName: 'Sichtbar wenn Referenzfeld Wert(e) nicht hat',
      template: {
        '@type': 'ShowOnFieldValueNotInValuesCondition',
        conditionFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        },
        values: []
      },
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select'
      ]
    },
    AndCondition: {
      displayName: 'Sichtbar wenn komplexe Bedingung erfüllt ist',
      template: {
        '@type': 'AndCondition',
        conditions: []
      }
    },
    OrCondition: {
      displayName: 'Sichtbar wenn komplexe Bedingung erfüllt ist',
      template: {
        '@type': 'OrCondition',
        conditions: []
      }
    },
    ShowOnProcessVariableInValuesCondition: {
      displayName: 'Sichtbar wenn Prozessvariable Wert(e) hat',
      template: {
        '@type': 'ShowOnProcessVariableInValuesCondition',
        variableName: '',
        values: []
      }
    },
    ShowOnProcessVariableNotInValuesCondition: {
      displayName: 'Sichtbar wenn Prozessvariable Wert(e) nicht hat',
      template: {
        '@type': 'ShowOnProcessVariableNotInValuesCondition',
        variableName: '',
        values: []
      }
    }
  },
  validationRules: {
    MaxDateValueValidator: {
      displayName: 'Maximales Datum',
      template: {
        '@type': 'MaxDateValueValidator',
        maxValue: null
      },
      properties: [
        { name: 'maxValue', displayName: 'Maximales Datum', hint: 'DATE' },
        { name: 'maxValueExpression', displayName: 'Platzhalter für maximales Datum' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MaxLengthValidator: {
      displayName: 'Maximale Länge',
      template: {
        '@type': 'MaxLengthValidator',
        maxLength: 5
      },
      properties: [
        { name: 'maxLength', displayName: 'Maximale Länge' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MaxNumberValueValidator: {
      displayName: 'Maximaler Zahlenwert',
      template: {
        '@type': 'MaxNumberValueValidator',
        maxValue: 10
      },
      properties: [
        { name: 'maxValue', displayName: 'Maximaler Wert' },
        {
          name: 'validationErrorMessage',
          displayName: 'Individuelle Fehlermeldung bei überschrittenem Maximalwert'
        },
        {
          name: 'validationInvalidNumberMessage',
          displayName: 'Individuelle Fehlermeldung falls Eingabe keine Zahl ist'
        }
      ]
    },
    MinDateValueValidator: {
      displayName: 'Minimales Datum',
      template: {
        '@type': 'MinDateValueValidator',
        minValue: null
      },
      properties: [
        { name: 'minValue', displayName: 'Minimales Datum', hint: 'DATE' },
        { name: 'minValueExpression', displayName: 'Platzhalter für minimales Datum' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MinNumberValueValidator: {
      displayName: 'Minimaler Zahlenwert',
      template: {
        '@type': 'MinNumberValueValidator',
        minValue: -1
      },
      properties: [
        { name: 'minValue', displayName: 'Minimaler Wert' },
        {
          name: 'validationErrorMessage',
          displayName: 'Individuelle Fehlermeldung bei unterschrittenem Minimalwert'
        },
        {
          name: 'validationInvalidNumberMessage',
          displayName: 'Individuelle Fehlermeldung falls Eingabe keine Zahl ist'
        }
      ]
    },
    RegexValidator: {
      displayName: 'Regulärer Ausdruck',
      template: {
        '@type': 'RegexValidator',
        regex: ''
      },
      properties: [
        { name: 'regex', displayName: 'Regex' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    NumberValidator: {
      displayName: 'Zahlenformat',
      template: {
        '@type': 'NumberValidator',
        nonNegative: true,
        digitsAfterDecimalPoint: 0
      },
      properties: [
        { name: 'nonNegative', displayName: 'Positiv' },
        { name: 'digitsAfterDecimalPoint', displayName: 'Anzahl der Nachkommastellen' },
        {
          name: 'validationErrorMessage',
          displayName: 'Individuelle Fehlermeldung falls Eingabe keine Zahl ist'
        },
        {
          name: 'validationDecimalPointError',
          displayName: 'Individuelle Fehlermeldung bei falscher Anzahl an Nachkommastellen'
        },
        {
          name: 'validationNonNegativeNumberError',
          displayName: 'Individuelle Fehlermeldung bei negativen Werten'
        }
      ]
    },
    EuroBetragNegativeValidator: {
      displayName: 'Negativer Geldbetrag',
      template: {
        '@type': 'EuroBetragNegativeValidator',
        strictlyNegative: false
      },
      properties: [
        { name: 'strictlyNegative', displayName: 'Streng' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    EuroBetragPositiveValidator: {
      displayName: 'Positiver Geldbetrag',
      template: {
        '@type': 'EuroBetragPositiveValidator',
        strictlyPositive: false
      },
      properties: [
        { name: 'strictlyPositive', displayName: 'Streng' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    RequiredOnEmptyFieldValidator: {
      displayName: 'Pflichtfeld wenn Referenzfeld leer',
      template: {
        '@type': 'RequiredOnEmptyFieldValidator',
        sourceFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        }
      },
      properties: [
        { name: 'sourceFieldKey', displayName: 'Feld' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ],
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select',
        'date',
        'time',
        'euro_betrag'
      ]
    },
    RequiredOnFilledFieldValidator: {
      displayName: 'Pflichtfeld wenn Referenzfeld ausgefüllt',
      template: {
        '@type': 'RequiredOnFilledFieldValidator',
        sourceFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        }
      },
      properties: [
        { name: 'sourceFieldKey', displayName: 'Feld' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ],
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select',
        'date',
        'time',
        'euro_betrag'
      ]
    },
    RequiredOnFieldValueValidator: {
      displayName: 'Pflichtfeld wenn Referenzfeld Wert(e) hat',
      template: {
        '@type': 'RequiredOnFieldValueValidator',
        sourceFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        },
        values: []
      },
      properties: [
        { name: 'sourceFieldKey', displayName: 'Feld' },
        { name: 'values', displayName: 'Werte:' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' },
        { name: 'valuesExpression', displayName: 'Platzhalter' }
      ],
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select'
      ]
    },
    RequiredOnFieldValueNotInValuesValidator: {
      displayName: 'Pflichtfeld wenn Referenzfeld Wert(e) nicht hat',
      template: {
        '@type': 'RequiredOnFieldValueNotInValuesValidator',
        sourceFieldKey: {
          groupId: '',
          groupIndex: 0,
          fieldId: ''
        },
        values: []
      },
      properties: [
        { name: 'sourceFieldKey', displayName: 'Feld' },
        { name: 'values', displayName: 'Werte:' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' },
        { name: 'valuesExpression', displayName: 'Platzhalter' }
      ],
      allowedReferenceFields: [
        'string',
        'string_ajax_autocomplete',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'radio_buttons',
        'dropdown_single_select',
        'dropdown_single_select_ajax',
        'dropdown_multiple_select',
        'two_list_select'
      ]
    },
    FileExtensionValidator: {
      displayName: 'Erlaubte Dateiendungen',
      template: {
        '@type': 'FileExtensionValidator',
        values: []
      },
      properties: [
        { name: 'values', displayName: 'Werte:' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MaxFilesizeValidator: {
      displayName: 'Maximale Dateigröße',
      template: {
        '@type': 'MaxFilesizeValidator',
        maxFilesize: ''
      },
      properties: [
        { name: 'maxFilesize', displayName: 'Maximale Dateigröße in Byte' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MaxTotalFilesizeValidator: {
      displayName: 'Maximale Gesamtuploadgröße',
      template: {
        '@type': 'MaxTotalFilesizeValidator',
        maxTotalFilesize: ''
      },
      properties: [
        { name: 'maxTotalFilesize', displayName: 'Maximale Gesamtuploadgröße in Byte' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    MaxFileCountValidator: {
      displayName: 'Maximale Dateianzahl',
      template: {
        '@type': 'MaxFileCountValidator',
        maxFileCount: null
      },
      properties: [
        { name: 'maxFileCount', displayName: 'Maximale Anzahl an Dateien' },
        { name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }
      ]
    },
    FileNameRegexValidator: {
      displayName: 'Dateinamenschema (Regulärer Ausdruck)',
      template: {
        '@type': 'FileNameRegexValidator',
        regex: ''
      },
      properties: [{ name: 'regex', displayName: 'Regulärer Ausdruck' }]
    },
    VerificationLevelValidator: {
      displayName: 'Verifizierung der Herkunft des Wertes',
      template: {
        '@type': 'VerificationLevelValidator',
        levels: ['NPA_READOUT']
      },
      levels: [
        {
          id: 'NPA_READOUT',
          displayName: 'Direkt aus Personalausweis gelesen'
        }
      ],
      properties: [{ name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }]
    },
    ExternalValidator: {
      displayName: 'Externe Validierung',
      template: {
        '@type': 'ExternalValidator',
        settings: {
          url: '',
          scope: 'CURRENT_FIELD'
        }
      },
      properties: [
        {
          name: 'settings',
          properties: [
            { name: 'url', displayName: 'URL der Datenquelle' },
            { name: 'proxyHost', displayName: 'Proxy-Host' },
            { name: 'proxyPort', displayName: 'Proxy-Port' },
            { name: 'scope', displayName: 'Zu übermittelnde Daten' }
          ]
        }
      ]
    },
    PdfAValidator: {
      displayName: 'PDF/A',
      template: {
        '@type': 'PdfAValidator',
        validationErrorMessage: ''
      },
      properties: [{ name: 'validationErrorMessage', displayName: 'Individuelle Fehlermeldung' }]
    }
  },
  referenceOptions: {
    disallowedRefValueSelectionTypes: [
      'ShowOnEmptyFieldCondition',
      'ShowOnFilledFieldCondition',
      'RequiredOnEmptyFieldValidator',
      'RequiredOnFilledFieldValidator'
    ]
  }
};

const loaFieldsForRechtsform = [
  {
    key: 'rechtsform',
    value: 'Rechtsform (ID)'
  },
  {
    key: 'rechtsformText',
    value: 'RechtsformText'
  }
];

const loaFieldsForRegister = [
  {
    key: 'registerGericht',
    value: 'Registergericht'
  },
  {
    key: 'registerNummer',
    value: 'Registernummer'
  },
  {
    key: 'registerArt',
    value: 'Registerart'
  }
];

const loaFieldsForHandelndePerson = [
  {
    key: 'handelndePersonVorname',
    value: 'Vorname (Handelnde Person)'
  },
  {
    key: 'handelndePersonNachname',
    value: 'Nachname (Handelnde Person)'
  },
  {
    key: 'handelndePersonGeburtsdatum',
    value: 'Geburtsdatum (Handelnde Person)'
  }
];

const loaFieldsForEid = [
  {
    key: 'communityId',
    value: 'Community-ID'
  },
  {
    key: 'pseudonymId',
    value: 'Pseudonym-ID'
  }
];

mappings.dropdownOptions['loaFieldsBasis'] = [
  ...mappings.dropdownOptions.loaFields,
  ...loaFieldsForRechtsform,
  ...loaFieldsForHandelndePerson,
  ...loaFieldsForRegister
];
mappings.dropdownOptions['loaFieldsSubstanziell'] = [
  ...mappings.dropdownOptions.loaFields,
  ...loaFieldsForRechtsform,
  ...loaFieldsForHandelndePerson,
  ...loaFieldsForRegister
];
mappings.dropdownOptions['loaFieldsHoch'] = [...mappings.dropdownOptions.loaFields, ...loaFieldsForEid];

angular.module('formApp').constant('mappings', mappings);
